import { combineReducers } from "redux";

import {
  CONSIGNEE_GET_LOADING,
  CONSIGNEE_GET_ERROR,
  CONSIGNEE_GET_SUCCESS,
  CONSIGNEE_VIEW_ERROR,
  CONSIGNEE_VIEW_LOADING,
  CONSIGNEE_VIEW_SUCCESS,
  CONSIGNEE_ADD_ERROR,
  CONSIGNEE_ADD_LOADING,
  CONSIGNEE_ADD_INVALID,
  CONSIGNEE_ADD_SUCCESS,
  CONSIGNEE_DELETE_ERROR,
  CONSIGNEE_DELETE_LOADING,
  CONSIGNEE_DELETE_SUCCESS,
  HANDLE_STATUS_LOADING,
  HANDLE_STATUS_SUCCESS,
  HANDLE_STATUS_ERROR,
  HANDLE_APPROVE_DOC_LOADING,
  HANDLE_APPROVE_DOC_SUCCESS,
  HANDLE_APPROVE_DOC_ERROR,
  CONSIGNEE_FETCH_HISTORY_LOADING,
  CONSIGNEE_FETCH_HISTORY_SUCCESS,
  CONSIGNEE_FETCH_HISTORY_ERROR,
} from "../actions/constant";

import {
  HANDLE_STATUS_USER_LOADING,
  HANDLE_STATUS_USER_SUCCESS,
  HANDLE_STATUS_USER_ERROR,
  HANDLE_STATUS_BRISTORE_LOADING,
  HANDLE_STATUS_BRISTORE_SUCCESS,
  HANDLE_STATUS_BRISTORE_ERROR,
  HANDLE_STATUS_PI_LOADING,
  HANDLE_STATUS_PI_SUCCESS,
  HANDLE_STATUS_PI_ERROR,
} from "../actions/consigneeAction";

const consigneeGetError = (state = false, action) => {
  switch (action.type) {
    case CONSIGNEE_GET_ERROR:
      return action.consigneeGetError;
    default:
      return state;
  }
};

const consigneeGetLoading = (state = false, action) => {
  switch (action.type) {
    case CONSIGNEE_GET_LOADING:
      return action.consigneeGetLoading;
    default:
      return state;
  }
};

const consigneeGetSuccess = (state = false, action) => {
  switch (action.type) {
    case CONSIGNEE_GET_SUCCESS:
      return action.consigneeGetSuccess;
    default:
      return state;
  }
};

const consignees = (state = [], action) => {
  switch (action.type) {
    case CONSIGNEE_GET_SUCCESS:
      return action.consignees;
    default:
      return state;
  }
};

const consigneeViewLoading = (state = false, action) => {
  switch (action.type) {
    case CONSIGNEE_VIEW_LOADING:
      return action.consigneeViewLoading;
    default:
      return state;
  }
};

const consigneeViewError = (state = false, action) => {
  switch (action.type) {
    case CONSIGNEE_VIEW_ERROR:
      return action.consigneeViewError;
    default:
      return state;
  }
};

const consigneeViewSuccess = (state = false, action) => {
  switch (action.type) {
    case CONSIGNEE_VIEW_SUCCESS:
      return action.consigneeViewSuccess;
    default:
      return state;
  }
};

const consignee = (state = [], action) => {
  switch (action.type) {
    case CONSIGNEE_VIEW_SUCCESS:
      return action.consignee;
    default:
      return state;
  }
};

const consigneeAddError = (state = false, action) => {
  switch (action.type) {
    case CONSIGNEE_ADD_ERROR:
      return action.consigneeAddError;
    default:
      return state;
  }
};

const consigneeAddLoading = (state = false, action) => {
  switch (action.type) {
    case CONSIGNEE_ADD_LOADING:
      return action.consigneeAddLoading;
    default:
      return state;
  }
};

const consigneeAddInvalid = (state = false, action) => {
  switch (action.type) {
    case CONSIGNEE_ADD_INVALID:
      return action.consigneeAddInvalid;
    default:
      return state;
  }
};

const invalid = (state = [], action) => {
  switch (action.type) {
    case CONSIGNEE_ADD_INVALID:
      return action.invalid;
    default:
      return state;
  }
};

const consigneeAddSuccess = (state = false, action) => {
  switch (action.type) {
    case CONSIGNEE_ADD_SUCCESS:
      return action.consigneeAddSuccess;
    default:
      return state;
  }
};

const consigneeAddSuccessVal = (state = false, action) => {
  switch (action.type) {
    case CONSIGNEE_ADD_SUCCESS:
      return action.consignee;
    default:
      return state;
  }
};

const consigneeDeleteError = (state = false, action) => {
  switch (action.type) {
    case CONSIGNEE_DELETE_ERROR:
      return action.consigneeDeleteError;
    default:
      return state;
  }
};

const consigneeDeleteLoading = (state = false, action) => {
  switch (action.type) {
    case CONSIGNEE_DELETE_LOADING:
      return action.consigneeDeleteLoading;
    default:
      return state;
  }
};

const consigneeDeleteSuccess = (state = false, action) => {
  switch (action.type) {
    case CONSIGNEE_DELETE_SUCCESS:
      return action.consigneeDeleteSuccess;
    default:
      return state;
  }
};

const handleStatusLoading = (state = false, action) => {
  switch (action.type) {
    case HANDLE_STATUS_LOADING:
      return action.handleStatusLoading;
    default:
      return state;
  }
};

const handleStatusSuccess = (state = false, action) => {
  switch (action.type) {
    case HANDLE_STATUS_SUCCESS:
      return action.handleStatusSuccess;
    default:
      return state;
  }
};

const handleStatusError = (state = false, action) => {
  switch (action.type) {
    case HANDLE_STATUS_ERROR:
      return action.handleStatusError;
    default:
      return state;
  }
};

const handleApproveDocLoading = (state = false, action) => {
  switch (action.type) {
    case HANDLE_APPROVE_DOC_LOADING:
      return action.handleApproveDocLoading;
    default:
      return state;
  }
};

const handleApproveDocSuccess = (state = false, action) => {
  switch (action.type) {
    case HANDLE_APPROVE_DOC_SUCCESS:
      return action.handleApproveDocSuccess;
    default:
      return state;
  }
};

const handleApproveDocError = (state = false, action) => {
  switch (action.type) {
    case HANDLE_APPROVE_DOC_ERROR:
      return action.handleApproveDocError;
    default:
      return state;
  }
};

const handleStatusUserLoading = (state = false, action) => {
  switch (action.type) {
    case HANDLE_STATUS_USER_LOADING:
      return action.handleStatusUserLoading;
    default:
      return state;
  }
};

const handleStatusUserSuccess = (state = false, action) => {
  switch (action.type) {
    case HANDLE_STATUS_USER_SUCCESS:
      return action.handleStatusUserSuccess;
    default:
      return state;
  }
};

const handleStatusUserError = (state = false, action) => {
  switch (action.type) {
    case HANDLE_STATUS_USER_ERROR:
      return action.handleStatusUserError;
    default:
      return state;
  }
};

// Handle Status Bristore Consignee Grid
const handleStatusBristoreLoading = (state = false, action) => {
  switch (action.type) {
    case HANDLE_STATUS_BRISTORE_LOADING:
      return action.handleStatusBristoreLoading;
    default:
      return state;
  }
};

const handleStatusBristoreSuccess = (state = false, action) => {
  switch (action.type) {
    case HANDLE_STATUS_BRISTORE_SUCCESS:
      return action.handleStatusBristoreSuccess;
    default:
      return state;
  }
};

const handleStatusBristoreError = (state = false, action) => {
  switch (action.type) {
    case HANDLE_STATUS_BRISTORE_ERROR:
      return action.handleStatusBristoreError;
    default:
      return state;
  }
};

// handle status pi

const handleStatusPiLoading = (state = false, action) => {
  switch (action.type) {
    case HANDLE_STATUS_PI_LOADING:
      return action.handleStatusPiLoading;
    default:
      return state;
  }
};

const handleStatusPiSuccess = (state = false, action) => {
  switch (action.type) {
    case HANDLE_STATUS_PI_SUCCESS:
      return action.handleStatusPiSuccess;
    default:
      return state;
  }
};

const handleStatusPiError = (state = false, action) => {
  switch (action.type) {
    case HANDLE_STATUS_PI_ERROR:
      return action.handleStatusPiError;
    default:
      return state;
  }
};

const consigneeFetchHistoryLoading = (state = false, action) => {
  switch (action.type) {
    case CONSIGNEE_FETCH_HISTORY_LOADING:
      return action.consigneeFetchHistoryLoading;
    default:
      return state;
  }
};

const consigneeFetchHistorySuccess = (state = false, action) => {
  switch (action.type) {
    case CONSIGNEE_FETCH_HISTORY_SUCCESS:
      return action.consigneeFetchHistorySuccess;
    default:
      return state;
  }
};

const consigneeFetchHistoryError = (state = false, action) => {
  switch (action.type) {
    case CONSIGNEE_FETCH_HISTORY_ERROR:
      return action.consigneeFetchHistoryError;
    default:
      return state;
  }
};

const cons = (state = [], action) => {
  switch (action.type) {
    case CONSIGNEE_FETCH_HISTORY_SUCCESS:
      return action.cons;
    default:
      return state;
  }
};

const consigneeReducer = combineReducers({
  consigneeGetError,
  consigneeGetLoading,
  consigneeGetSuccess,
  consignees,

  consigneeViewLoading,
  consigneeViewError,
  consigneeViewSuccess,
  consignee,

  consigneeAddSuccessVal,
  consigneeAddError,
  consigneeAddLoading,
  consigneeAddInvalid,
  invalid,
  consigneeAddSuccess,

  consigneeDeleteError,
  consigneeDeleteLoading,
  consigneeDeleteSuccess,

  handleStatusLoading,
  handleStatusSuccess,
  handleStatusError,

  handleStatusUserLoading,
  handleStatusUserSuccess,
  handleStatusUserError,

  handleStatusBristoreLoading,
  handleStatusBristoreSuccess,
  handleStatusBristoreError,

  handleStatusPiLoading,
  handleStatusPiError,
  handleStatusPiSuccess,

  handleApproveDocError,
  handleApproveDocLoading,
  handleApproveDocSuccess,

  consigneeFetchHistoryError,
  consigneeFetchHistoryLoading,
  consigneeFetchHistorySuccess,
  cons,
});

export default consigneeReducer;
